<template>
  <footer class="bg-gray-50 border-t border-gray-200 mt-auto">
    <div
      class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[2.5rem] flex items-center"
    >
      <div class="relative w-full">
        <div class="text-center text-xs text-gray-400">
          <p>Copyright (C) aimfactory Inc.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts"></script>

<style scoped></style>
